import { PropTypes } from "base/react-libs";
import { useOpenClose } from "@evertrue/et-components";
import { useEffect, useState } from "react";
import JourneyTaskModal from "apps/journeys/components/modals/journey-task-modal";
import EmptyStateMessage from "components/lists/empty-state-message";
import AddJourneyTaskButton from "apps/journeys/components/top-nav/add-journey-task-button";
import StepRow from "apps/journeys/components/detail/journey-detail-table/step-view/step-row/step-row";

const StepsTable = ({
  journey = {},
  userIsCreator = false,
  openContactSummary = () => {},
  handleEditJourneyTask = () => {},
  handleCreateJourneyTask = () => {},
  handleDeleteJourneyTask = () => {},
  optionalStateManagementFunction = () => {},
}) => {
  const { steps: journeySteps } = journey;
  const [isOpen, openModal, closeModal] = useOpenClose();

  const generateEmptyStateMessage = () => {
    if (Object.keys(journey).length && !(journeySteps && journeySteps.length)) {
      return "This Cadence does not have any steps yet.";
    } else return "Please select a Cadence.";
  };

  //Groups journey steps by day number & asign to state
  // takes in [ {day_number: 1, ...}, {day_number: 1, ...}, {day_number: 2, ...}]
  // returns {1: [{day_number: 1, ...}, {day_number: 1, ...}], 2: [{day_number: 2, ...}]
  const [groupedSteps, setGroupedSteps] = useState([]);
  useEffect(() => {
    if (journeySteps) {
      const arrangedData = {};
      journeySteps.forEach((step) => {
        const { day_number } = step;
        if (!arrangedData[day_number]) {
          arrangedData[day_number] = [];
        }
        arrangedData[day_number].push(step);
      });
      setGroupedSteps(arrangedData);
    }
  }, [journeySteps]);

  return (
    <>
      {Object.keys(journey).length && journeySteps && journeySteps.length ? (
        <>
          {groupedSteps &&
            Object.entries(groupedSteps).map(([day, steps], i) => (
              <div key={`day-${day}`}>
                <div className="journeys-task-table-row--header">Day {day}</div>
                {steps &&
                  steps.map((step, subIndex) => (
                    <StepRow
                      key={`task-${step.id}`}
                      step={step}
                      journey={journey}
                      userIsCreator={userIsCreator}
                      isFinalStep={!!(i === Object.entries(groupedSteps).length - 1) && subIndex === steps.length - 1} // final step of final day
                      openContactSummary={openContactSummary}
                      handleEditJourneyTask={handleEditJourneyTask}
                      handleDeleteJourneyTask={handleDeleteJourneyTask}
                      optionalStateManagementFunction={optionalStateManagementFunction}
                    />
                  ))}
              </div>
            ))}
          {userIsCreator && (
            <AddJourneyTaskButton journey={journey} handleCreateJourneyTask={handleCreateJourneyTask} />
          )}
        </>
      ) : (
        <>
          {userIsCreator ? (
            <>
              <EmptyStateMessage
                size="page"
                icon="cadences"
                iconKit="gt2"
                text="Build your Cadence by adding a step"
                actionLabel="Add Step"
                onAction={isOpen ? closeModal : openModal}
              >
                {`Create steps for your new Cadence!`}
              </EmptyStateMessage>
              <JourneyTaskModal
                isOpen={isOpen}
                onClose={closeModal}
                journey={journey}
                handleCreateJourneyTask={handleCreateJourneyTask}
              />
            </>
          ) : (
            <EmptyStateMessage size="page" text={generateEmptyStateMessage()} />
          )}
        </>
      )}
    </>
  );
};

StepsTable.propTypes = {
  journey: PropTypes.object.isRequired,
  openContactSummary: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
  handleCreateJourneyTask: PropTypes.func,
  handleEditJourneyTask: PropTypes.func,
  handleDeleteJourneyTask: PropTypes.func,
  userIsCreator: PropTypes.bool,
};

export default StepsTable;
